import { useSelector } from "react-redux";
import { useTranslate } from "@tolgee/react";
import { Roles } from "@evennt-tech/api-v2-core";
import { selectUser } from "store/auth/selectors";
import useViewMode, { ViewMode } from "store/viewMode/viewMode.store";
import { LocalizedNameTranslate } from "tools/localization/resolveLocalizedName";

export const useLocalizedNameTranslate = (): LocalizedNameTranslate => {
  const { t } = useTranslate();
  const { role } = useSelector(selectUser);
  const { mode } = useViewMode();

  const isExhibitor = role === Roles.EXHIBITOR || mode === ViewMode.EXHIBITOR;

  return isExhibitor ? t : null;
};
